import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from "./components/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NftDetails from "./components/Nftdetail";
import CreateNFT from "./components/createNFT";
import NftCollection from "./components/NFTcollection";
import Ranking from "./components/ranking";
import PhysicalDetails from "./components/physicaldetail";
import ProjectPage from "./components/ProjectPage";
import Collectionexpand from "./components/Collectionexpand";
import AccountPage from "./components/account";
import MyCart from "./components/Cart/MyCart";
import Checkout from "./components/Checkout/Checkout";
import Digitalitem from "./components/Digitalitem/Digitalitem";
import NewToken from "./components/newToken/NewToken";
import Physicalitem from "./components/physicalitem/Physicalitem";
import ShopCreate from "./components/shopCreate/ShopCreate";
import Login from "./components/login/login";
import SignUp from "./components/signup/signup";
import Header from "./components/small/Header.tsx";
import CreateCollection from "./components/createCollection";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyNFTs from "./components/mynfts";

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <BrowserRouter>
        <Header />

        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/nft-detail/:id" element={<NftDetails />}></Route>
          <Route path="/createnft" element={<CreateNFT />}></Route>
          <Route path="/nftcollection" element={<NftCollection />}></Route>
          <Route path="/ranking" element={<Ranking />}></Route>
          <Route path="/physicaldetail" element={<PhysicalDetails />}></Route>
          <Route path="/projectpage" element={<ProjectPage />}></Route>
          <Route path="/account" element={<AccountPage />}></Route>
          <Route path="/cart" element={<MyCart />}></Route>
          <Route path="/checkout" element={<Checkout />}></Route>
          <Route path="/digitalitem" element={<Digitalitem />}></Route>
          <Route path="/newtoken" element={<NewToken />}></Route>
          <Route path="/physicalitem" element={<Physicalitem />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/signup" element={<SignUp />}></Route>
          <Route path="/mynfts" element={<MyNFTs />}></Route>
          <Route path="/shopcreate" element={<ShopCreate />}></Route>
          <Route
            path="/createcollection"
            element={<CreateCollection />}
          ></Route>
          <Route
            path="/collectionexpand"
            element={<Collectionexpand />}
          ></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
